import banner1 from "../src/assets/banner-01.jpg";
import banner2 from "../src/assets/banner-02.jpg";
import banner3 from "../src/assets/banner-03.jpg";

export const BANNER = [
  {
    id: 1,
    image: banner1,
    title: "Horizot",
    title2: "Forbidden West",
    arrival: "New Arrival",
    btn: "Shop Now",
  },
  {
    id: 2,
    image: banner2,
    title: "God of War",
    title2: "Raganarok",
    arrival: "New Arrival",
    btn: "Shop Now",
  },
  {
    id: 3,
    image: banner3,
    title: "The Witcher 3",
    title2: "Wild Hunt",
    arrival: "New Arrival",
    btn: "Shop Now",
  },
];
